import { render, staticRenderFns } from "./newScenarioPlan.vue?vue&type=template&id=2e67c108&scoped=true&"
import script from "./newScenarioPlan.vue?vue&type=script&lang=js&"
export * from "./newScenarioPlan.vue?vue&type=script&lang=js&"
import style0 from "./newScenarioPlan.vue?vue&type=style&index=0&id=2e67c108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67c108",
  null
  
)

export default component.exports